/**
 * @file useClassTransform
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import { getKeys } from '@tencent/glue-util-types';
import { camelCase } from '@tencent/glue-util-helper';
import { useClassInstance } from '../context/class';
export function useClassTransform(list) {
    var styleMap = useClassInstance();
    var res = {};
    var rest = [];
    list.forEach(function (name) {
        var classes = name.match(/[^\x20\t\r\n\f]+/g) || [];
        classes.forEach(function (className) {
            var style = styleMap[camelCase(className)];
            if (style == null) {
                rest.push(className);
                return;
            }
            getKeys(style).forEach(function (key) {
                var value = style[key];
                if (value != null) {
                    res[key] = value;
                }
            });
        });
    });
    return [res, rest.join(' ')];
}
